import ApplicationModel, { attr } from '../ApplicationModel';
import { type ProjectDefaultBookmarkAttributes } from './generated/ProjectDefaultBookmarkAttributes';
import { model } from '../modelBuilder';

interface ProjectDefaultBookmark extends ProjectDefaultBookmarkAttributes {}

@model
class ProjectDefaultBookmark extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProjectDefaultBookmark' = 'ProjectDefaultBookmark';
  get typename(): 'ProjectDefaultBookmark' {
    return 'ProjectDefaultBookmark';
  }

  static internalTypename: 'ProjectDefaultBookmark' = 'ProjectDefaultBookmark';
  get internalTypename(): 'ProjectDefaultBookmark' {
    return 'ProjectDefaultBookmark';
  }

  static inputType = 'ProjectDefaultBookmarkAttributes!';

  static filterType = 'ProjectDefaultBookmarkFilters';
  static filters = { projectId: 'ID', projectConfigurationId: 'ID' };

  static fields = {
    bookmarkId: attr({ writable: true, readable: true }),
    bookmarkName: attr({ readable: true }),
    bookmarkType: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    projectConfigurationId: attr({ writable: true, readable: true }),
    projectId: attr({ writable: true, readable: true }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    projectConfiguration: attr.belongsTo({
      readable: true,
      typename: 'ProjectConfiguration',
    }),
  };
  // End auto-generated
}

export default ProjectDefaultBookmark;
